/**
 * PortalRedirect — mounted on the root "/" route inside ProtectedRoute.
 * Redirects authenticated users to their customer-type portal.
 * Admin users (no customer_type) fall through to the legacy /dashboard.
 */

import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '@/contexts/AuthContext'

const PORTAL_MAP: Record<string, string> = {
  consultant: '/consulente',
  pmi: '/pmi',
  research: '/ricerca',
  association: '/associazione',
  public_body: '/ente',
  media: '/media',
  observatory: '/osservatorio',
}

export function PortalRedirect() {
  const { user } = useAuth()
  const location = useLocation()

  // If the user is already inside any portal path (including admin), do not redirect again.
  const portalPaths = [...Object.values(PORTAL_MAP), '/admin']
  const inPortal = portalPaths.some((p) => location.pathname.startsWith(p))
  if (inPortal) return null

  // Admin users go to the admin console
  if (user?.role === 'admin' || user?.role === 'super_admin') {
    return <Navigate to="/admin" replace />
  }

  const portal = PORTAL_MAP[user?.customer_type ?? '']
  if (!portal) return <Navigate to="/dashboard" replace />
  return <Navigate to={portal} replace />
}
